/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDto } from './WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDto';
import {
    WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDtoFromJSON,
    WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDtoFromJSONTyped,
    WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDtoToJSON,
} from './WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDto';

/**
 * Sends the mail to one address as a test. No invite is created.
 * @export
 * @interface WebApiServicesDataTransferObjectsInviteServiceSendTestEventMailDto
 */
export interface WebApiServicesDataTransferObjectsInviteServiceSendTestEventMailDto {
    /**
     * The event the mail is for.
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsInviteServiceSendTestEventMailDto
     */
    eventId?: number;
    /**
     * The message written by the admin.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsInviteServiceSendTestEventMailDto
     */
    message?: string | null;
    /**
     * 
     * @type {WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDto}
     * @memberof WebApiServicesDataTransferObjectsInviteServiceSendTestEventMailDto
     */
    design?: WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDto;
    /**
     * True for a reminder, false for an invite.
     * @type {boolean}
     * @memberof WebApiServicesDataTransferObjectsInviteServiceSendTestEventMailDto
     */
    isReminder?: boolean;
    /**
     * The subject of an invite. A reminder has a fixed subject.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsInviteServiceSendTestEventMailDto
     */
    subject?: string | null;
    /**
     * The address to send the test to.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsInviteServiceSendTestEventMailDto
     */
    email?: string | null;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsInviteServiceSendTestEventMailDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsInviteServiceSendTestEventMailDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsInviteServiceSendTestEventMailDtoFromJSON(json: any): WebApiServicesDataTransferObjectsInviteServiceSendTestEventMailDto {
    return WebApiServicesDataTransferObjectsInviteServiceSendTestEventMailDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsInviteServiceSendTestEventMailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsInviteServiceSendTestEventMailDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'eventId': !exists(json, 'eventId') ? undefined : json['eventId'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'design': !exists(json, 'design') ? undefined : WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDtoFromJSON(json['design']),
        'isReminder': !exists(json, 'isReminder') ? undefined : json['isReminder'],
        'subject': !exists(json, 'subject') ? undefined : json['subject'],
        'email': !exists(json, 'email') ? undefined : json['email'],
    };
}

export function WebApiServicesDataTransferObjectsInviteServiceSendTestEventMailDtoToJSON(value?: WebApiServicesDataTransferObjectsInviteServiceSendTestEventMailDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'eventId': value.eventId,
        'message': value.message,
        'design': WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDtoToJSON(value.design),
        'isReminder': value.isReminder,
        'subject': value.subject,
        'email': value.email,
    };
}

